import React from 'react'

export default function InternalBanner(props) {
  return (
    <section className={`single-banner internal-banner ${ props.category ? `internal-banner-${props.category}` : '' } ${props.className || ''}`}>
      <div className="container">
        <h2>{props.title}</h2>
        <h4>{props.venue}</h4>
        <h4>{props.description}</h4>

        {props.children && (
          <div className="mt-3">
            {props.children}
          </div>
        )}
      </div>
    </section>
  )
}
